import { ProcedureInstanceBase, ProcedureInstanceBaseParams } from './procedureInstanceBase';

export interface ProcedureTemplateInstanceBaseParams extends ProcedureInstanceBaseParams {
  latest?: boolean;
  procedureId?: string;
  majorVersion?: number;
  minorVersion?: number;
  patchVersion?: number;
}

export class ProcedureTemplateInstance extends ProcedureInstanceBase {
  latest: boolean;
  procedureId: string;
  majorVersion: number;
  minorVersion: number;
  patchVersion: number;

  constructor(params: ProcedureTemplateInstanceBaseParams) {
    super(params);
    this.latest = params.latest || false;
    this.procedureId = params.procedureId || '';
    this.majorVersion = params.majorVersion || 0;
    this.minorVersion = params.minorVersion || 0;
    this.patchVersion = params.patchVersion || 0;
  }
};


